import React from "react";
import styles from "./styles.module.css";
import { useHistory } from "react-router-dom";
import DeleteApp from "./deleteapp";

export default function Card({ app, onDelete }) {
  const history = useHistory();

  const handleEdit = () => {
    history.push(`/${app.id}/canvas/pages/index`);
  };
  const handlePreview = () => {
    window.open(
      `https://app.brevitybuilder.com/preview/${app.id}/index`,
      app.id
    );
  };

  const handleDelete = () => {};
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{app.name}</div>
      <div style={{ display: "flex" }}>
        <button onClick={handleEdit} className={styles.cardButton}>
          Edit
        </button>
        <button onClick={handlePreview} className={styles.cardButton}>
          Preview
        </button>
        <div style={{ flexGrow: 1 }} />
        <DeleteApp onSubmit={onDelete} appId={app.id} />
      </div>
    </div>
  );
}
